<template>
  <div class="d-flex flex-column">
    <span class="d-inline-block font-weight-bold text-subtitle-1" v-html="title"></span>
    <span class="text-body-2 text--secondary">{{ subtitle }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: String
  }
};
</script>
